import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import './App.css';
import { Home } from './components/home';
import { About } from './components/about';
import { Contact } from './components/contact';
import { WeddingCards } from './components/weddingcards';
import { CardDetails } from './components/carddetails';
import { WeddingWebsite } from './components/weddingwebsite';
import {
  WeddingPage,
  Puberty,
  Housewarming,
  Earpiercing,
  Birthday,
  BusinessCards,
  SaveTheDate,
  CategoryPage,
} from './components/categorypages';
import { ScrollToTop } from './components/ScrollToTop';
import { Preloader } from './components/Preloader';

function App() {
  return (
    <>
      {/* Show preloader once on initial app load */}
      <Preloader />

      <HashRouter>
        {/* Scrolls to top on every page navigation */}
        <ScrollToTop />

        <Routes>
          <Route path="/home" element={<Navigate to="/" />} />
          <Route path="/" exact={true} element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* All cards (no category filter) */}
          <Route path="/cards" element={<WeddingCards />} />
          <Route path="/carddetails/:id" element={<CardDetails />} />

          {/* Category-specific pages */}
          <Route path="/wedding" element={<WeddingPage />} />
          <Route path="/puberty" element={<Puberty />} />
          <Route path="/housewarming" element={<Housewarming />} />
          <Route path="/earpiercing" element={<Earpiercing />} />
          <Route path="/birthday" element={<Birthday />} />
          <Route path="/business" element={<BusinessCards />} />
          <Route path="/savethedate" element={<SaveTheDate />} />

          {/* Wedding website portfolio page */}
          <Route path="/weddingwebsite" element={<WeddingWebsite />} />
          <Route path="/:category" element={<CategoryPage />} />
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
